import { useNavigate } from 'react-router-dom';
import Agents from '@/components/Agents';

export function AgentsPage() {
  const navigate = useNavigate();

  return <Agents onBack={() => navigate('/dashboard')} />;
}
